import { render } from "./ModalMovie.vue?vue&type=template&id=1eebf0c1&scoped=true"
import script from "./ModalMovie.vue?vue&type=script&lang=js"
export * from "./ModalMovie.vue?vue&type=script&lang=js"

import "./ModalMovie.vue?vue&type=style&index=0&id=1eebf0c1&scoped=true&lang=scss"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eebf0c1"]])

export default __exports__